import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import units from 'ha/theme/units';
import CitiesTitle from './CitiesTitle';
import AppartmentsTitle from './AppartmentsTitle';
import RoomsTitle from './RoomsTitle';
import Separator from '../Separator';
import MobileSuggestions from './MobileSuggestions';
import { Suggestion } from '../../types';

export const styles = createStyles({
  substrate: {
    backgroundColor: '#f8f9fa',
    overflow: 'auto',
  },
  section: {
    marginBottom: units.rem('4.5'),
  },
  citiesTitle: {
    fontSize: units.rem(1.5),
  },
  mobileTitle: {
    marginTop: units.rem(3),
    marginBottom: units.rem(1.25),
    padding: units.txb(0, 1.5, 0),
    fontSize: units.rem(1.5),
  },
});

interface Props {
  cities: Suggestion[];
  appartments: Suggestion[];
  rooms: Suggestion[];
}

export const SuggestionsMobileLayout: React.SFC<
  Props & WithStyles<typeof styles>
> = ({ cities, appartments, rooms, classes }) => (
  <React.Fragment>
    <div className={classes.section}>
      <CitiesTitle
        wrapperClassName={classes.mobileTitle}
        titlesClassName={classes.citiesTitle}
      />
      <MobileSuggestions list={cities} />
    </div>

    <Separator />

    <div className={classes.substrate}>
      <div className={classes.section}>
        <AppartmentsTitle align="center" className={classes.mobileTitle} />
        <MobileSuggestions list={appartments} />
      </div>
      <div className={classes.section}>
        <RoomsTitle align="center" className={classes.mobileTitle} />
        <MobileSuggestions list={rooms} />
      </div>
    </div>
  </React.Fragment>
);

export default withStyles(styles)(SuggestionsMobileLayout);
